import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import {
  createEventGroup,
  deleteEventGroupById,
  updateEventGroupById,
} from '../thunks/eventGroups';

const eventGroupsAdapter = createEntityAdapter({});

export const eventGroupsSlice = createSlice({
  name: 'eventGroups',
  initialState: eventGroupsAdapter.getInitialState({}),
  reducers: {
    setEventGroups: (state, action) => {
      eventGroupsAdapter.upsertMany(state, action.payload);
    },
    addNewEventGroup: (state, action) => {
      eventGroupsAdapter.addOne(state, action.payload);
    },
    removeEventGroup: (state, action) => {
      eventGroupsAdapter.removeOne(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createEventGroup.fulfilled, (state, action) => {
        eventGroupsAdapter.upsertOne(state, action.payload);
      })
      .addCase(deleteEventGroupById.fulfilled, (state, action) => {
        eventGroupsAdapter.removeOne(state, action.payload.id);
      })
      .addCase(updateEventGroupById.fulfilled, (state, action) => {
        const { id } = action.payload;
        eventGroupsAdapter.updateOne(state, {
          id,
          changes: action.payload,
        });
      });
  },
});

export const { setEventGroups, addNewEventGroup, removeEventGroup } =
  eventGroupsSlice.actions;

export const eventGroupsAdapterSelectors = eventGroupsAdapter.getSelectors(
  (state) => state.eventGroups
);

export default eventGroupsSlice.reducer;
